import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import routes from './routes';
import withTracker from '../hocs/withTracker';


const Routes = props => (
  <Router {...props} basename={process.env.PUBLIC_URL}>
    <div>
      {
        routes.map((route) => {
          const { component, path } = route;
          return (
            <Route
              {...route}
              component={withTracker(component)}
              path={path}
              key={path}
            />
          );
        })
      }
    </div>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js